module.exports = __webpack_public_path__ + "img/phone-card-header.7f7da73b.jpg";